import { FilterByFieldInfoModel } from '@main-application/shared/services/summary-report-settings.service';
import { SummaryConfigType, baseColumnConfig, reportViewConfig } from '@shared/constants/summary.const';
import { HeaderViewEnum } from '@ui-components/components/summary-header-toggle-group/summary-header-toggle-group.component';

export enum UserSummaryGroupType {
  UserType = 1,
  Property,
  UserIsActive,
  Role,
  Portfolio,
  EmailDomain,
  HasEmailAsLogin,
  HasPhoneAsLogin,
  WebLoggedInWithinLastWeek,
  WebLoggedInLastMonth,
  AppUsedWithinLastWeek,
  AppUsedWithinLastMonth,
  MobileAppVersion,
  UserName,
}

export enum ServiceViewEnum {
  SERVICE_VIEW = 'serviceView',
}

export enum UserStatusFilterValues {
  due = 'due',
  pending = 'pending',
  inProgress = 'inProgress',
  waitingParts = 'waitingParts',
  reopened = 'reopened',
  completed = 'completedStatusCategoryTotal',
}

export const userReportViewConfig: reportViewConfig[] = [
  {
    id: 1,
    label: 'All Users',
  },
];

export const userSummaryConfig: SummaryConfigType = {
  key: 'users-summary',
  queries: [
    {
      queryId: 1,
      configColumns: [
        'total',
        'webLoggedInWithinLastWeek',
        'webLoggedInWithinLastMonth',
        'appUsedWithinLastWeek',
        'appUsedWithinLastMonth',
        'webLoggedInWithin24h',
        'webLoggedInWithin48h',
        'appUsedWithin24h',
        'appUsedWithin48h',
      ],
      columns: {
        total: {
          key: 'total',
          displayKey: 'Total',
          ...baseColumnConfig,
        },
        webLoggedInWithin24h: {
          key: 'webLoggedInWithin24h',
          displayKey: 'Web 24h',
          tooltip: 'Web logged-in within 24h',
          ...baseColumnConfig,
        },
        webLoggedInWithin48h: {
          key: 'webLoggedInWithin48h',
          displayKey: 'Web 48h',
          tooltip: 'Web logged-in within 48h',
          ...baseColumnConfig,
        },
        webLoggedInWithinLastWeek: {
          key: 'webLoggedInWithinLastWeek',
          displayKey: 'Web 7d',
          tooltip: 'Web logged-in within the Last Week',
          ...baseColumnConfig,
        },
        webLoggedInWithinLastMonth: {
          key: 'webLoggedInWithinLastMonth',
          displayKey: 'Web 30d',
          tooltip: 'Web logged-in within the Last Month',
          ...baseColumnConfig,
        },
        appUsedWithin24h: {
          key: 'appUsedWithin24h',
          displayKey: 'App 24h',
          tooltip: 'App used within 24h',
          ...baseColumnConfig,
        },
        appUsedWithin48h: {
          key: 'appUsedWithin48h',
          displayKey: 'App 48h',
          tooltip: 'App used within 48h',
          ...baseColumnConfig,
        },
        appUsedWithinLastWeek: {
          key: 'appUsedWithinLastWeek',
          displayKey: 'App 7d',
          tooltip: 'App used within the Last Week',
          ...baseColumnConfig,
        },
        appUsedWithinLastMonth: {
          key: 'appUsedWithinLastMonth',
          displayKey: 'App 30d',
          tooltip: 'App used within the Last Month',
          ...baseColumnConfig,
        },
      },
    },
  ],
};

export const SELECT_FILTER_SHOW_BY_CONFIG: FilterByFieldInfoModel[] = Object.keys(UserSummaryGroupType)
  .filter(key => Number.isNaN(Number(key)) && key !== UserSummaryGroupType[UserSummaryGroupType.Portfolio])
  .map(key => {
    const label = key
      .replace(/([A-Z])/g, ' $1')
      .replace(/\bTicket\b/g, '')
      .trim();

    return {
      fieldType: UserSummaryGroupType[key as keyof typeof UserSummaryGroupType],
      label,
      isDescending: true,
    };
  });

export enum BOARDS_VIEWS {
  NEW_INSPECTIONS = 'new-inspections',
  SURVEY_VIEW = 'survey',
}

export enum BoardsViewEnum {
  BOARDS_VIEW = 'boardsView',
}

export type InspectionViewConfig = {
  [BoardsViewEnum.BOARDS_VIEW]: HeaderViewEnum;
};

export const ServiceSummaryArrayFieldsToSerialize = [
  'assigneeIds',
  'ticketTypes',
  'createdByIds',
  'statuses',
  'propertyIds',
  'collectionIds',
  'reportingCategoryIds',
  'reportingTopicIds',
  'ticketCategoryIds',
  'topicIds',
  'boardIds',
  'scheduleIds',
  'unitType',
];

export const ServiceSummaryNumberFieldsToParse = [
  'collectionId',
  'ticketCategoryId',
  'unitTypeId',
  'topicId',
  'ticketTypeId',
  'boardId',
  'timeframe',
  'portfolioId',
  'isCompleted',
  'periodDateSearchFields',
];
export const ServiceSummaryDateFieldsToParse = ['customEndDate', 'customStartDate'];
